import fetch from "cross-fetch";
import axios from 'axios';
let { basePath, UserVehicle } = require('./constants');
let { UsersAPI, VehiclesAPI, BadgesAPI } = require('./constants');

function _createRequest(api, headers) {
  return axios.create({
    baseURL: UsersAPI.FIND,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...headers
    },
  });
}

export const _createWarrantyRequest = (api, headers, ) => {
  return axios.create({
    baseURL: BadgesAPI.FIND,
    headers: _createHeaders(),
  });
}

/**
 *  Create Request to Vehicles API
 */
 export const _createVehiclesUserRequest = (api, headers) => {
  return axios.create({
    baseURL: UserVehicle.FIND,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
      ...headers

    },
  });
}

export const _createReviewSerialRequest = (api, headers) => {
  return axios.create({
    baseURL: BadgesAPI.FIND,
    headers: _createHeaders()
  });
}

/**
 *  Create Request to Vehicles API
 */
export const _createVehiclesRequest = () => {
  return axios.create({
    baseURL: VehiclesAPI.FIND,
    headers: _createHeaders(),
  });
}

/**
 *  Create Request to Users API
 */
export const _createUsersRequest = (userLoggedData) => {
  return axios.create({
    baseURL: UsersAPI.FIND,
    headers: _createHeaders(userLoggedData),

  });
}


/*
* Fetch Values with options
*/
const fetchValuesOptions = (endpoint, options, callback) => {
  return fetch(endpoint, options)
    .then(
      response => {
        if(response.status === 200) {
          return response.json()
        } else {
          return {error: true}
        }
      },
      error => alert('Error')
    )
    .then(result => {
      return callback(result);
    })
    .catch(error => {
      // console.log('REQUEST INITIAL', error)
    });
}

/**
 * Handle redirect when request has errors
 * @param {*} error returned from api
 */
const handleErrorRedirect = (err) => {
  console.error('REQUEST ERROR REDIRECT', err)
  if(err && err.response) {
    if(err.response.status === 401) {
      console.error('REQUEST ERROR REDIRECT 401', err.response)
      window.location.href = `${basePath()}/error?t=expired`
    }
    if(err.response.status === 404) {
      console.error('REQUEST ERROR REDIRECT 404', err.response)
      if(err.response.data && err.response.data.body && err.response.data.body.indexOf('not found') > -1) {
        window.location.href = `${basePath()}/user-form`
      } else {
        console.log('error', err.response)
        window.location.href = `${basePath()}/error`
      }
    }
  } 
  
}

/*** PRIVATE METHODS ***/
/**
 * Create Headers with Authorization and user infos
 */
function _createHeaders(userLoggedData) {
  let userData = userLoggedData ? userLoggedData : JSON.parse(localStorage.getItem('user-data'));  
  let token = sessionStorage.getItem('id_token');
  if(!userData) window.location.href = `${basePath()}/login-redirect`
  return  {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "countryCode": 'BR',
    'id_token': userData.token,
    'Authorization': `Bearer ${userData.token}`,
    'transactionID': userData.email,
    'timeout': 5000
  }
}

const REQUEST = () => ({
  _fetchValuesOptions: fetchValuesOptions,
  _createRequest: _createRequest,
  _createWarrantyRequest: _createWarrantyRequest,
  _createReviewSerialRequest: _createReviewSerialRequest,
  _createVehiclesUserRequest: _createVehiclesUserRequest,
  _handleErrorRedirect: handleErrorRedirect
})

export default REQUEST;
